import { localizationService } from "infrastructure/services/LocalizationService"

export const useTranslate = (key, options) => {
  const result = localizationService.t(key, options)
  return result === key ? null : result
}
